import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, User, LogOut, ShieldCheck, Wrench } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const link = ({ isActive }) =>
    `text-sm font-medium px-3 py-2 rounded-md transition-colors ${
      isActive ? "text-[#0B1C30]" : "text-slate-600 hover:text-[#0B1C30]"
    }`;

  return (
    <header
      className="sticky top-0 z-50 bg-white/85 backdrop-blur-md border-b border-[#E2E8F0]"
      data-testid="site-header"
    >
      <div className="tk-container flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <div className="w-8 h-8 rounded-md bg-[#0B1C30] flex items-center justify-center">
            <span className="text-white text-sm font-bold tracking-tight">tk</span>
          </div>
          <span className="font-semibold text-lg text-[#0B1C30] tracking-tight">tekkdeler<span className="text-[#4A7C59]">.no</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {!user && (
            <>
              <NavLink to="/butikk" className={link} data-testid="nav-shop">Butikk</NavLink>
              <NavLink to="/diagnose" className={link} data-testid="nav-diagnose">Diagnose</NavLink>
              <NavLink to="/verksted" className={link} data-testid="nav-fixers">Verksteder</NavLink>
              <NavLink to="/om-oss" className={link} data-testid="nav-about">Om oss</NavLink>
            </>
          )}
          {user?.role === "customer" && (
            <>
              <NavLink to="/butikk" className={link} data-testid="nav-shop">Butikk</NavLink>
              <NavLink to="/diagnose" className={link} data-testid="nav-diagnose">Diagnose</NavLink>
              <NavLink to="/verksted" className={link} data-testid="nav-fixers">Verksteder</NavLink>
              <NavLink to="/om-oss" className={link} data-testid="nav-about">Om oss</NavLink>
            </>
          )}
          {user?.role === "fixer" && (
            <>
              <NavLink to="/verksted-dashbord" className={link} data-testid="nav-fixer-dashboard-link">Dashbord</NavLink>
              <NavLink to="/verksted/oppdrag" className={link} data-testid="nav-fixer-jobs">Oppdrag</NavLink>
              <NavLink to="/verksted/faktura" className={link} data-testid="nav-fixer-invoices-link">Fakturering</NavLink>
              <NavLink to="/verksted/profil" className={link} data-testid="nav-fixer-profile-link">Profil</NavLink>
            </>
          )}
        </nav>

        <div className="flex items-center gap-2">
          {user && user.role === "admin" && (
            <Link to="/admin" className="tk-btn-secondary !py-2 !px-3 text-sm" data-testid="nav-admin">
              <ShieldCheck size={16} /> Admin
            </Link>
          )}
          {user && user.role === "fixer" && (
            <Link to="/verksted-dashbord" className="tk-btn-secondary !py-2 !px-3 text-sm" data-testid="nav-fixer-dashboard">
              <Wrench size={16} /> Verksted
            </Link>
          )}
          {user && user.role === "customer" && (
            <Link to="/mine-bestillinger" className="tk-btn-secondary !py-2 !px-3 text-sm" data-testid="nav-my-orders">
              <ShoppingBag size={16} /> Bestillinger
            </Link>
          )}
          {user ? (
            <button
              className="tk-btn-secondary !py-2 !px-3 text-sm"
              onClick={() => { logout(); navigate("/"); }}
              data-testid="logout-btn"
            >
              <LogOut size={16} /> Logg ut
            </button>
          ) : (
            <>
              <Link to="/logg-inn" className="tk-btn-secondary !py-2 !px-3 text-sm" data-testid="nav-login">
                <User size={16} /> Logg inn
              </Link>
              <Link to="/registrer" className="tk-btn-primary !py-2 !px-3 text-sm" data-testid="nav-register">
                Registrer
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
